<template>
  <main>
    <contact-us-blurb />
    <div
      v-if="$route.query.share"
      class="container-fluid bg-white pt-4"
    >
      <div class="container">
        <share-portal-notification
          :name="patient"
          :isvalid="isvalid"
        />
      </div>
    </div>
    <div class="container-fluid bg-white pt-4">
      <div class="container">
        <food-navbar
          :source="$route.query.share ? 'share_portal' : 'tracker'"
          current="food-insights"
        />
      </div>
    </div>
    <div
      v-if="isvalid"
      class="container-fluid bg-white py-5"
    >
      <div class="container">
        <div class="page-sidebar-layout">
          <div class="side main">
            <div class="page-title-box">
              <span>Daily Intake for </span>
              <date-picker
                v-model="selectedDate"
                :thetype="date_type"
                @input="update_date"
                @choose-type="update_type"
              />
            </div>

            <div
              v-if="is_free_user"
              class="upgrade-blurb"
            >
              <h6>Unlock with Premium</h6>
              <p>You've found a feature that's only available to Premium users.  The information below is sample data.  You're on the Free plan, which gives you all the basic benefits of FFF without the bells and whistles.  Upgrade to the Premium plan today to unlock more.</p>
              <div class="button-container">
                <a
                  href="/account/subscriptions"
                  class="button"
                >Yes Please!</a>
              </div>
            </div>

            <div class="container-fluid bg-white pt-5">
              <h2>
                Daily FOOD COLOR Averages <i
                  v-tooltip:top="`Here you will find all of the foods you have entered into your daily food log sorted by their respective color.<br/><br/>Too many red foods? Too little green? Use this FOOD SPIRAL® to find balance in your days with the colors and find your way to a healthy balance! <br/><br/>GREY color = No foods in the food group have been eaten.`"
                  style="font-size: 16px;"
                  class="text-primary fa fa-info-circle"
                  data-html="true"
                />
              </h2>
              <div class="spiral-labels">
                <div class="split">
                  <div class="side labels">
                    <div class="labels-box">
                      <div
                        v-for="(food_group, index) in food_groupsinsights"
                        v-if="food_group.name != 'Uncategorized'"
                        class="label"
                        :class="['food-group-' + (index + 1)]"
                      >
                        <div class="text">
                          <div class="title">
                            Food Group: {{ food_group.name }}
                          </div>
                          <div class="values">
                            <div :class="'value green'+(food_group.green_percentage>0?' b':'')">
                              Green: {{ food_group.green_percentage }}%
                            </div>
                            <div :class="'value yellow'+(food_group.yellow_percentage>0?' b':'')">
                              Yellow: {{ food_group.yellow_percentage }}%
                            </div>
                            <div :class="'value red'+(food_group.red_percentage>0?' b':'')">
                              Red: {{ food_group.red_percentage }}%
                            </div>
                          </div>
                        </div>
                        <div class="line" />
                      </div>
                    </div>
                  </div>
                  <div class="side spiral">
                    <canvas
                      id="canvas"
                      width="350"
                      height="350"
                    />
                  </div>
                </div>
              </div>
            </div>

            <div class="container-fluid bg-white pt-5">
              <div class="insight-stats">
                <div class="side breakdown">
                  <div class="box">
                    <div class="box-title">
                      Colors Eaten Today
                    </div>
                    <div class="chart-split">
                      <div class="chart-container">
                        <color-total-chart :chart_data="color_totals" />
                      </div>
                      <div class="data-container">
                        <div class="color-line-items">
                          <div class="line-item green">
                            <strong>Green:</strong> {{ color_totals[0] }}%
                          </div>
                          <div class="line-item yellow">
                            <strong>Yellow:</strong> {{ color_totals[1] }}%
                          </div>
                          <div class="line-item red">
                            <strong>Red:</strong> {{ color_totals[2] }}%
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div
                  v-if="fluid_goal>0"
                  class="side fluids"
                >
                  <div class="box">
                    <!-- <div class="box-title">Fluid Intake</div> -->
                    <div class="chart-split">
                      <div class="chart-container">
                        <div class="jar-container">
                          <img
                            src="/img/jar-mask.png"
                            alt=""
                          >
                          <div
                            class="fluid"
                            :style="{height: ((fluid_current / fluid_goal) * 100) + '%'}"
                          />
                        </div>
                      </div>
                      <div class="data-container">
                        <div class="box-title">
                          {{ fluid_current }} Cups
                          <i
                            v-tooltip:top="fluid_current_tooltip"
                            class="text-primary fa fa-info-circle"
                            data-html="true"
                          />
                        </div>
                        <div class="box-subtitle">
                          Out of {{ fluid_goal }} Cup goal
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div class="container-fluid bg-white pt-5">
              <h2 class="text-center pb-3">
                Food Groups Eaten: <i
                  v-tooltip:top="'Here you will find all of the foods you have entered into your daily food log sorted in their respective food groups.Too many in one group and not the other?<br/><br/>Learn what food groups you need to maintain, or eat more or less of, and find your way to a healthy balance!'"
                  style="font-size: 16px;"
                  class="text-primary fa fa-info-circle"
                  data-html="true"
                />
              </h2>

              <div class="food-group-stats">
                <div class="split">
                  <div
                    v-for="(food_group, index) in food_groups"
                    class="food-group"
                  >
                    <div class="box">
                      <div class="box-title">
                        {{ food_group.name }}
                      </div>
                      <ul>
                        <li v-for="(food, index) in food_group.foods">
                          {{ food.toLowerCase() }}
                        </li>
                      </ul>
                      <div
                        v-if="!food_group.foods || !food_group.foods.length"
                        style="text-align:center;"
                      >
                        ---
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div class="side sidebar">
            <factor-scale
              :factor="scorecard.total_food_factor"
              :individual_factor="scorecard.individual_factor"
            />

            <goal-scale :goaldata="goaldata" />
          </div>
        </div>
      </div>
    </div>
  </main>
</template>

<script>
import moment from 'moment'
import ColorTotalChart from '../components/ColorTotalChart.js'
import DatePicker from "../components/DatePicker";

export default {
  name: 'FoodInsights',
  components: {
    DatePicker,
    ColorTotalChart
  },
  data() {
    return {
      usertype:'',
      usersub:'',
      isvalid:true,
      patient:'',
      chart_is_built: false,
      food_groupsinsights: [
        {
          name: 'Fats',
          green_percentage: 0,
          yellow_percentage: 0,
          red_percentage: 0
        },
        {
          name: 'Meats & Proteins',
          green_percentage: 0,
          yellow_percentage: 0,
          red_percentage: 0
        },
        {
          name: 'Vegetables',
          green_percentage: 0,
          yellow_percentage: 0,
          red_percentage: 0
        },
        {
          name: 'Milk & Dairy',
          green_percentage: 0,
          yellow_percentage: 0,
          red_percentage: 0
        },
        {
          name: 'Fruits',
          green_percentage: 0,
          yellow_percentage: 0,
          red_percentage: 0
        },
        {
          name: 'Breads & Starches',
          green_percentage: 0,
          yellow_percentage: 0,
          red_percentage: 0
        },
      ],
      food_groups: [
        {
          name: 'Fats',
          foods: ['Please complete first the Health Assesment and choose one spiral.']
        },
        {
          name: 'Meats & Proteins',
          foods: ['Please complete first the Health Assesment and choose one spiral.']
        },
        {
          name: 'Vegetables',
          foods: ['Please complete first the Health Assesment and choose one spiral.']
        },
        {
          name: 'Milk & Dairy',
          foods: ['Please complete first the Health Assesment and choose one spiral.']
        },
        {
          name: 'Fruits',
          foods: ['Please complete first the Health Assesment and choose one spiral.']
        },
        {
          name: 'Breads & Starches',
          foods: ['Please complete first the Health Assesment and choose one spiral.']
        },
      ],
      color_totals: [0, 0, 0],
      fluid_max: 8,
      fluid_goal: 4,
      fluid_current: 0,
      // fluid_current_tooltip: `${this.fluid_current} cups / ${parseFloat(this.fluid_current * 8).toFixed(1)} ounces / ${parseFloat(this.fluid_current * 236.6).toFixed(1)} cc`,
      goaldata:{},
      scorecard:{
        individual_factor:0,
        total_food_factor:0
      }
    };
  },
  computed: {
    is_free_user: function () {
      console.log('is_free_user');
      if ( this.usertype == 'Guest' && this.usersub == 'individual' ) { return false; }
      return !this.$parent.user || this.$parent.user.type != 'individual';
    },
    selectedDate: {
      get: function () {
        return this.$store.state.selection.dateOnFoodTrackerScreen;
      },
      set: function (newValue) {
        this.$store.dispatch('selection/setDateOnFoodTrackerScreen', newValue);
      },
    },
    date_type: {
      get: function () {
        return this.$store.state.selection.dateTypeOnFoodTrackerScreen;
      },
      set: function (newValue) {
        this.$store.dispatch('selection/setDateTypeOnFoodTrackerScreen', newValue);
      },
    },
  },
  mounted(){
    this.check_user();
    this.load_data();
  },
  methods: {
    async check_user(){
      console.log('check user');
      await this.$store.dispatch('loading/increment');

      let checkuser = await this.$http('/api/share-portal/usertype',{
        method:"get",
      }).then(response => response.json())
        .then(async function(json) {
          if(json.message == "Unauthenticated."){
            throw new Error(JSON.stringify(json));
          }else{
            return json;
          }
        });

      await this.$store.dispatch('loading/decrement');

      this.usersub = checkuser.subscription;

      if(checkuser.type=="Guest"){
        this.usertype = "Guest";
      }
      if(checkuser.type=="User"){
        this.usertype = "User";
      }
    },
    moment() {
      return moment();
    },
    update_date(date) {
      this.load_data();
    },
    update_type(type) {
      this.date_type = type;
    },
    async load_data(){
      console.log('load_data');
      if (this.is_free_user) {
        await this.check_user(); // try again after loading this
      }
      if (this.is_free_user) {
        // Dummy data
        var insights = await JSON.parse('{"data":[{"name":"Fats","foods":[],"green_percentage":0,"yellow_percentage":0,"red_percentage":0},{"name":"Meats & Protein","foods":["CHICKEN THIGH, RAW"],"green_percentage":100,"yellow_percentage":0,"red_percentage":0},{"name":"Vegetables","foods":["BROCCOLI, COOKED"],"green_percentage":100,"yellow_percentage":0,"red_percentage":0},{"name":"Milk & Dairy","foods":["WHOLE MILK"],"green_percentage":0,"yellow_percentage":0,"red_percentage":100},{"name":"Fruits","foods":["BLUEBERRIES,RAW"],"green_percentage":100,"yellow_percentage":0,"red_percentage":0},{"name":"Breads & Starches","foods":["POTATO SALAD","TOASTER PASTRIES,FRUIT,FROSTED"],"green_percentage":0,"yellow_percentage":11,"red_percentage":89},{"name":"Uncategorized","foods":[],"green_percentage":0,"yellow_percentage":0,"red_percentage":0}],"meta":{"goals":{"total_assesments":86,"weight":{"start_weight":"185","weight":"185","goal_weight":"lose","target_weight":"15","perweek_weight":".5","goal":170,"goal_weight_weeks":"0\/30","goal_weight_change":55},"exercise":{"date_goal":"2021-02-09","steps_current":"1000","steps_goals":"3000","weekly_frequency":"2-3","duration":"100","type":"light"},"fluids":{"current":260,"goal":"1420"},"sleep":{"days_6_to_8":"3","goal":7},"calories":{"current":937,"goal":1550}},"patient":"AI User 2 !sc!","score_card":{"individual_factor":10,"total_food_factor":7},"total_green_food_percentage":56,"total_yellow_food_percentage":3,"total_red_food_percentage":41}}');
      } else {
        await this.$store.dispatch('loading/increment');

        var insights = await this.$http('/api/meals/foodinsights',{
          method:"post",
          body:JSON.stringify({
            'timezone':Intl.DateTimeFormat().resolvedOptions().timeZone,
            'date':this.selectedDate,
            'type':this.date_type
          })
        }).then(response => response.json())
          .then(async function(json) {
            if(json.message == "Unauthenticated."){
              throw new Error(JSON.stringify(json));
            }else{
              return json;
            }
          });

        await this.$store.dispatch('loading/decrement');
      }

      // console.log('LOG', JSON.parse(JSON.stringify(insights, function(k, v) { return v === undefined ? null : v; })));

      if ( insights.hasOwnProperty('exception') ) {
        // this.isvalid=false;
        console.log('error on insights, loading dummy data');

        // Dummy data
        insights = await JSON.parse('{"message": "dummy","data":[{"name":"Fats","foods":[],"green_percentage":0,"yellow_percentage":0,"red_percentage":0},{"name":"Meats & Protein","foods":["Please fill out health assessment to continue."],"green_percentage":0,"yellow_percentage":0,"red_percentage":0},{"name":"Vegetables","foods":["Please fill out health assessment to continue."],"green_percentage":0,"yellow_percentage":0,"red_percentage":0},{"name":"Milk & Dairy","foods":["Please fill out health assessment to continue."],"green_percentage":0,"yellow_percentage":0,"red_percentage":0},{"name":"Fruits","foods":["Please fill out health assessment to continue."],"green_percentage":0,"yellow_percentage":0,"red_percentage":0},{"name":"Breads & Starches","foods":["Please fill out health assessment to continue."],"green_percentage":0,"yellow_percentage":0,"red_percentage":0},{"name":"Uncategorized","foods":[],"green_percentage":0,"yellow_percentage":0,"red_percentage":0}],"meta":{"goals":{"total_assesments":0,"weight":{"start_weight":"0","weight":"185","goal_weight":"lose","target_weight":"0","perweek_weight":"0","goal":0,"goal_weight_weeks":"0\/30","goal_weight_change":0},"exercise":{"date_goal":"2021-02-09","steps_current":"0","steps_goals":"3000","weekly_frequency":"2-3","duration":"100","type":"light"},"fluids":{"current":0,"goal":"1420"},"sleep":{"days_6_to_8":"0","goal":7},"calories":{"current":0,"goal":1550}},"patient":"Please fill out health assessment to continue.","score_card":{"individual_factor":0,"total_food_factor":0},"total_green_food_percentage":0,"total_yellow_food_percentage":0,"total_red_food_percentage":0}}');

        // return false;
      }

      if(insights.message == "Invalid."){
        this.isvalid=false;
        console.log('not valid insights');
        return false;
      }

      this.patient  = insights.meta.patient;
      this.goaldata = insights.meta.goals;
      this.scorecard.individual_factor = insights.meta.score_card.individual_factor;
      this.scorecard.total_food_factor = insights.meta.score_card.total_food_factor;


      this.color_totals = [
        insights.meta.total_green_food_percentage,
        insights.meta.total_yellow_food_percentage,
        insights.meta.total_red_food_percentage
      ];
      this.food_groupsinsights = insights.data;

      this.load_foods_eaten();

      this.fluid_goal=0;
      if(insights.meta.goals.fluids){
        this.fluid_goal = Math.round(parseFloat(insights.meta.goals.fluids.goal/237));
        this.fluid_current = parseFloat(insights.meta.goals.fluids.current/237).toFixed(2);
      }


      // console.log("insights");
      // console.log(insights);
      // console.log(this.date);
      // console.log(this.date_2);



      let chart_data = {
        'cat1_green': insights.data[0].green_percentage, 'cat1_yellow': insights.data[0].yellow_percentage, 'cat1_red': insights.data[0].red_percentage,
        'cat2_green': insights.data[1].green_percentage, 'cat2_yellow': insights.data[1].yellow_percentage, 'cat2_red': insights.data[1].red_percentage,
        'cat3_green': insights.data[2].green_percentage, 'cat3_yellow': insights.data[2].yellow_percentage, 'cat3_red': insights.data[2].red_percentage,
        'cat4_green': insights.data[3].green_percentage, 'cat4_yellow': insights.data[3].yellow_percentage, 'cat4_red': insights.data[3].red_percentage,
        'cat5_green': insights.data[4].green_percentage, 'cat5_yellow': insights.data[4].yellow_percentage, 'cat5_red': insights.data[4].red_percentage,
        'cat6_green': insights.data[5].green_percentage, 'cat6_yellow': insights.data[5].yellow_percentage, 'cat6_red': insights.data[5].red_percentage,
      };

      if (!this.chart_is_built) {
        this.render_horn_chart(chart_data);
      } else {
        this.update_horn_chart(chart_data);
      }
    },
    async load_foods_eaten(){
      if (this.is_free_user) {
        // Dummy data
        var foodseaten = await JSON.parse('[{"name":"Breads & Starches","foods":["POTATO SALAD","TOASTER PASTRIES,FRUIT,FROSTED"]},{"name":"Fats","foods":[]},{"name":"Fruits","foods":["BLUEBERRIES,RAW"]},{"name":"Meats & Protein","foods":["CHICKEN THIGH, RAW"]},{"name":"Milk & Dairy","foods":["WHOLE MILK"]},{"name":"Vegetables","foods":["BROCCOLI, COOKED"]},{"name":"Uncategorized","foods":[]}]');
      } else {
        var foodseaten = await this.$http('/api/meals/foodgroupseaten',{
          method:"post",
          body:JSON.stringify({
            'timezone':Intl.DateTimeFormat().resolvedOptions().timeZone,
            'date':this.selectedDate,
            'type':this.date_type
          })
        }).then(response => response.json())
          .then(async function(json) {
            if(json.message == "Unauthenticated."){
              throw new Error(JSON.stringify(json));
            }else{
              return json.data;
            }
          });
      }
      console.log("Foods eaten");
      console.log(foodseaten);
      this.food_groups =foodseaten;
    },
    render_horn_chart(cat_percent) {
      let cvs = document.getElementById('canvas')
      let ctx = cvs.getContext('2d');
      ctx.scale(3, 3);
      this.update_horn_chart(cat_percent);
      this.chart_is_built = true;

      // this.update_horn_chart({
      // 	"cat1_green" : 13, "cat1_yellow" : 53, "cat1_red" : 34,
      // 	"cat2_green" : 10, "cat2_yellow" : 20, "cat2_red" : 70,
      // 	"cat3_green" : 35, "cat3_yellow" : 40, "cat3_red" : 25,
      // 	"cat4_green" : 40, "cat4_yellow" : 20, "cat4_red" : 40,
      // 	"cat5_green" : 15, "cat5_yellow" : 50, "cat5_red" : 35,
      // 	"cat6_green" : 20, "cat6_yellow" : 40, "cat6_red" : 40,
      // });

    },
    fluid_current_tooltip() {
      return `${parseFloat(this.fluid_current).toFixed(2)} cups<br/>${parseFloat(this.fluid_current*8).toFixed(2)} ounces<br/>${parseFloat(this.fluid_current*236.6).toFixed(2)} cc`
    },
    update_horn_chart(cat_percent) {

      console.log('horn_chart', cat_percent);

      let cvs = document.getElementById('canvas')
      let ctx = cvs.getContext('2d');

      let gradient_offset = 0.0;
      let outline_thickness = 0.7;
      let line_thickness = 0.011;
      let rect_height = 0.2; // 0.260167;

      // var a1 =  98;
      // var a2 =  43;
      // var a3 =  80;
      let glp = {
        'c1': [77, 85, 80, 113, 67.5, 0],
        'c2': [87, 80, 80, 113, 67.5, 0],
        'c3': [97, 64, 80, 113, 67.5, 0],
        'c4': [99, 53, 80, 113, 67.5, 0],
        'c5': [96, 40, 80, 113, 67.5, 0],
        'c6': [98, 43, 80, 113, 67.5, 0]
      }

      // let glp = {
      // 	'c1': [90,7, 113,67.5],
      // 	'c2': [46,10, 113,67.5],
      // 	'c3': [25,34, 113,67.5],
      // 	'c4': [23,54, 113,67.5],
      // 	'c5': [27,70, 113,67.5],
      // 	'c6': [28,80, 113,67.5]
      // }

      let glc = {
        'c1': {
          'g': ['#B7D985', '#B7D985'],
          'y': ['#B6902E', '#B6902E'],
          'r': ['#F27587', '#F27587'],
          'w': ['rgb(230, 230, 230)']
        },
        'c2': {
          'g': ['#A2D171', '#A2D171'],
          'y': ['#D4AF37', '#D4AF37'],
          'r': ['#E9424E', '#E9424E'],
          'w': ['rgb(220, 220, 220)']
        },
        'c3': {
          'g': ['#629C44', '#629C44'],
          'y': ['#F8DC18', '#F8DC18'],
          'r': ['#ED1E24', '#ED1E24'],
          'w': ['rgb(210, 210, 210)']
        },
        'c4': {
          'g': ['#679A46', '#679A46'],
          'y': ['#E8C71E', '#E8C71E'],
          'r': ['#DB1F2A', '#DB1F2A'],
          'w': ['rgb(200, 200, 200)']
        },
        'c5': {
          'g': ['#56823B', '#56823B'],
          'y': ['#C4A636', '#C4A636'],
          'r': ['#851820', '#851820'],
          'w': ['rgb(190, 190, 190)']
        },
        'c6': {
          'g': ['#314A25', '#314A25'],
          'y': ['#89762E', '#89762E'],
          'r': ['#590E0E', '#590E0E'],
          'w': ['rgb(180, 180, 180)']
        }
      }

      // Store the current transformation matrix
      ctx.save();

      // Use the identity matrix while clearing the canvas
      ctx.setTransform(1, 0, 0, 1, 0, 0);
      ctx.clearRect(0, 0, cvs.width, cvs.height);

      // Restore the transform
      ctx.restore();

      // make sure we have a num val for everything
      for (var key in cat_percent) {
        if (cat_percent.hasOwnProperty(key)) {
          if (isNaN(cat_percent[key]) || cat_percent[key] == null) {
            cat_percent[key] = 0;
          }
        }
      }

      // #!! cat6
      ctx.beginPath();
      ctx.globalAlpha = 1.0;
      ctx.strokeStyle = 'rgb(0, 0, 0)';
      ctx.lineWidth = line_thickness;
      ctx.lineJoin = 'bevel';
      ctx.moveTo(113.437220, 68.134557);
      ctx.bezierCurveTo(79.341065, 57.997938, 75.082903, 30.910466, 89.760999, 6.125422);
      ctx.bezierCurveTo(80.981510, 1.891245, 74.718339, 1.351481, 67.097720, 2.246945);
      ctx.bezierCurveTo(-27.682686, 13.384167, 29.206667, 162.796180, 113.437220, 68.134557);

      let tmp_cat = "6";
      var tmp_color2_a = 0;
      if (cat_percent["cat" + tmp_cat + "_green"] != 0) {
        var tmp_color1_a = 0;
        var tmp_color1_b = (cat_percent["cat" + tmp_cat + "_green"] / 100) - gradient_offset;
        tmp_color2_a = tmp_color1_b + gradient_offset;
        if ( tmp_color2_a > 1) { tmp_color2_a = 1; }
        if ( tmp_color1_b > 1) { tmp_color1_b = 1; }
      }
      var tmp_color3_a = tmp_color2_a;
      if (cat_percent["cat" + tmp_cat + "_yellow"] != 0) {
        var tmp_color2_b = tmp_color2_a + (cat_percent["cat" + tmp_cat + "_yellow"] / 100) - gradient_offset;
        tmp_color3_a = tmp_color2_b + gradient_offset;
        if ( tmp_color3_a > 1) { tmp_color3_a = 1; }
        if ( tmp_color2_b > 1) { tmp_color2_b = 1; }
      }
      var tmp_color3_b = tmp_color3_a;
      if (cat_percent["cat" + tmp_cat + "_red"] != 0) {
        tmp_color3_b = tmp_color3_a + (cat_percent["cat" + tmp_cat + "_red"] / 100);
        if ( tmp_color3_b > 1) { tmp_color3_b = 1; }
      }

      // var gradient = ctx.createLinearGradient(glp['c' + tmp_cat][0], glp['c' + tmp_cat][1], glp['c' + tmp_cat][2], glp['c' + tmp_cat][3]);
      var gradient = ctx.createRadialGradient(
        glp['c' + tmp_cat][0], glp['c' + tmp_cat][1], glp['c' + tmp_cat][2],
        glp['c' + tmp_cat][3], glp['c' + tmp_cat][4], glp['c' + tmp_cat][5]
      );
      if (cat_percent["cat" + tmp_cat + "_green"] != 0) {
        gradient.addColorStop(tmp_color1_a, glc['c' + tmp_cat]['g'][0]);
        gradient.addColorStop(tmp_color1_b, glc['c' + tmp_cat]['g'][1]);
      }
      if (cat_percent["cat" + tmp_cat + "_yellow"] != 0) {
        gradient.addColorStop(tmp_color2_a, glc['c' + tmp_cat]['y'][0]);
        gradient.addColorStop(tmp_color2_b, glc['c' + tmp_cat]['y'][0]);
      }
      if (cat_percent["cat" + tmp_cat + "_red"] != 0) {
        gradient.addColorStop(tmp_color3_a, glc['c' + tmp_cat]['r'][0]);
        gradient.addColorStop(tmp_color3_b, glc['c' + tmp_cat]['r'][0]);
      }

      if ((cat_percent["cat" + tmp_cat + "_green"] == 0) && (cat_percent["cat" + tmp_cat + "_yellow"] == 0) && (cat_percent["cat" + tmp_cat + "_red"] == 0)) {
        ctx.fillStyle = glc['c' + tmp_cat]['w'][0];
      } else {
        ctx.fillStyle = gradient;
      }

      ctx.fill();
      ctx.stroke();

      // #!! cat5
      ctx.beginPath();
      ctx.globalAlpha = 1.0;
      ctx.strokeStyle = 'rgb(0, 0, 0)';
      ctx.lineWidth = line_thickness;
      ctx.lineJoin = 'bevel';
      ctx.moveTo(113.437220, 68.134557);
      ctx.bezierCurveTo(79.341065, 57.997938, 75.082903, 30.910466, 89.760999, 6.125422);
      ctx.bezierCurveTo(80.981510, 1.891245, 74.717365, 1.343229, 67.097720, 2.246945);
      ctx.bezierCurveTo(40.449252, 5.407549, 25.338120, 19.178598, 20.200573, 37.412511);
      ctx.bezierCurveTo(16.309920, 51.852162, 17.455140, 68.595258, 26.164641, 78.975438);
      ctx.bezierCurveTo(41.318784, 94.610477, 80.358866, 98.287003, 113.437220, 68.134557);

      tmp_cat = "5";
      tmp_color2_a = 0;
      if (cat_percent["cat" + tmp_cat + "_green"] != 0) {
        var tmp_color1_a = 0;
        var tmp_color1_b = (cat_percent["cat" + tmp_cat + "_green"] / 100) - gradient_offset;
        tmp_color2_a = tmp_color1_b + gradient_offset;
        if ( tmp_color2_a > 1) { tmp_color2_a = 1; }
        if ( tmp_color1_b > 1) { tmp_color1_b = 1; }
      }
      tmp_color3_a = tmp_color2_a;
      if (cat_percent["cat" + tmp_cat + "_yellow"] != 0) {
        var tmp_color2_b = tmp_color2_a + (cat_percent["cat" + tmp_cat + "_yellow"] / 100) - gradient_offset;
        tmp_color3_a = tmp_color2_b + gradient_offset;
        if ( tmp_color3_a > 1) { tmp_color3_a = 1; }
        if ( tmp_color2_b > 1) { tmp_color2_b = 1; }
      }
      tmp_color3_b = tmp_color3_a;
      if (cat_percent["cat" + tmp_cat + "_red"] != 0) {
        tmp_color3_b = tmp_color3_a + (cat_percent["cat" + tmp_cat + "_red"] / 100);
        if ( tmp_color3_b > 1) { tmp_color3_b = 1; }
      }

      // var gradient = ctx.createLinearGradient(glp['c' + tmp_cat][0], glp['c' + tmp_cat][1], glp['c' + tmp_cat][2], glp['c' + tmp_cat][3]);
      var gradient = ctx.createRadialGradient(
        glp['c' + tmp_cat][0], glp['c' + tmp_cat][1], glp['c' + tmp_cat][2],
        glp['c' + tmp_cat][3], glp['c' + tmp_cat][4], glp['c' + tmp_cat][5]
      );
      if (cat_percent["cat" + tmp_cat + "_green"] != 0) {
        gradient.addColorStop(tmp_color1_a, glc['c' + tmp_cat]['g'][0]);
        gradient.addColorStop(tmp_color1_b, glc['c' + tmp_cat]['g'][1]);
      }
      if (cat_percent["cat" + tmp_cat + "_yellow"] != 0) {
        gradient.addColorStop(tmp_color2_a, glc['c' + tmp_cat]['y'][0]);
        gradient.addColorStop(tmp_color2_b, glc['c' + tmp_cat]['y'][0]);
      }
      if (cat_percent["cat" + tmp_cat + "_red"] != 0) {
        gradient.addColorStop(tmp_color3_a, glc['c' + tmp_cat]['r'][0]);
        gradient.addColorStop(tmp_color3_b, glc['c' + tmp_cat]['r'][0]);
      }

      if ((cat_percent["cat" + tmp_cat + "_green"] == 0) && (cat_percent["cat" + tmp_cat + "_yellow"] == 0) && (cat_percent["cat" + tmp_cat + "_red"] == 0)) {
        ctx.fillStyle = glc['c' + tmp_cat]['w'][0];
      } else {
        ctx.fillStyle = gradient;
      }

      ctx.fill();
      ctx.stroke();

      // #!! cat4
      ctx.beginPath();
      ctx.globalAlpha = 1.0;
      ctx.strokeStyle = 'rgb(0, 0, 0)';
      ctx.lineWidth = line_thickness;
      ctx.lineJoin = 'bevel';
      ctx.moveTo(113.437220, 68.134557);
      ctx.bezierCurveTo(79.341065, 57.997938, 75.082903, 30.910466, 89.760999, 6.125422);
      ctx.bezierCurveTo(80.981510, 1.891245, 74.717365, 1.343229, 67.097720, 2.246945);
      ctx.bezierCurveTo(40.449252, 5.407549, 25.338120, 19.178598, 20.200573, 37.412511);
      ctx.bezierCurveTo(16.309920, 51.852162, 17.644129, 54.610137, 19.172082, 63.950883);
      ctx.bezierCurveTo(34.987683, 78.735477, 77.618540, 94.223759, 113.437220, 68.134557);

      tmp_cat = "4";
      tmp_color2_a = 0;
      if (cat_percent["cat" + tmp_cat + "_green"] != 0) {
        var tmp_color1_a = 0;
        var tmp_color1_b = (cat_percent["cat" + tmp_cat + "_green"] / 100) - gradient_offset;
        tmp_color2_a = tmp_color1_b + gradient_offset;
        if ( tmp_color2_a > 1) { tmp_color2_a = 1; }
        if ( tmp_color1_b > 1) { tmp_color1_b = 1; }
      }
      tmp_color3_a = tmp_color2_a;
      if (cat_percent["cat" + tmp_cat + "_yellow"] != 0) {
        var tmp_color2_b = tmp_color2_a + (cat_percent["cat" + tmp_cat + "_yellow"] / 100) - gradient_offset;
        tmp_color3_a = tmp_color2_b + gradient_offset;
        if ( tmp_color3_a > 1) { tmp_color3_a = 1; }
        if ( tmp_color2_b > 1) { tmp_color2_b = 1; }
      }
      tmp_color3_b = tmp_color3_a;
      if (cat_percent["cat" + tmp_cat + "_red"] != 0) {
        tmp_color3_b = tmp_color3_a + (cat_percent["cat" + tmp_cat + "_red"] / 100);
        if ( tmp_color3_b > 1) { tmp_color3_b = 1; }
      }

      // var gradient = ctx.createLinearGradient(glp['c' + tmp_cat][0], glp['c' + tmp_cat][1], glp['c' + tmp_cat][2], glp['c' + tmp_cat][3]);
      var gradient = ctx.createRadialGradient(
        glp['c' + tmp_cat][0], glp['c' + tmp_cat][1], glp['c' + tmp_cat][2],
        glp['c' + tmp_cat][3], glp['c' + tmp_cat][4], glp['c' + tmp_cat][5]
      );
      if (cat_percent["cat" + tmp_cat + "_green"] != 0) {
        gradient.addColorStop(tmp_color1_a, glc['c' + tmp_cat]['g'][0]);
        gradient.addColorStop(tmp_color1_b, glc['c' + tmp_cat]['g'][1]);
      }
      if (cat_percent["cat" + tmp_cat + "_yellow"] != 0) {
        gradient.addColorStop(tmp_color2_a, glc['c' + tmp_cat]['y'][0]);
        gradient.addColorStop(tmp_color2_b, glc['c' + tmp_cat]['y'][0]);
      }
      if (cat_percent["cat" + tmp_cat + "_red"] != 0) {
        gradient.addColorStop(tmp_color3_a, glc['c' + tmp_cat]['r'][0]);
        gradient.addColorStop(tmp_color3_b, glc['c' + tmp_cat]['r'][0]);
      }

      if ((cat_percent["cat" + tmp_cat + "_green"] == 0) && (cat_percent["cat" + tmp_cat + "_yellow"] == 0) && (cat_percent["cat" + tmp_cat + "_red"] == 0)) {
        ctx.fillStyle = glc['c' + tmp_cat]['w'][0];
      } else {
        ctx.fillStyle = gradient;
      }

      ctx.fill();
      ctx.stroke();

      // #!! cat3
      ctx.beginPath();
      ctx.globalAlpha = 1.0;
      ctx.strokeStyle = 'rgb(0, 0, 0)';
      ctx.lineWidth = line_thickness;
      ctx.lineJoin = 'bevel';
      ctx.moveTo(113.437220, 68.134557);
      ctx.bezierCurveTo(79.341065, 57.997938, 75.082903, 30.910466, 89.760999, 6.125422);
      ctx.bezierCurveTo(80.981510, 1.891245, 74.717365, 1.343229, 67.097720, 2.246945);
      ctx.bezierCurveTo(40.449252, 5.407549, 25.338120, 19.178598, 20.200573, 37.412511);
      ctx.bezierCurveTo(16.309920, 51.852162, 19.439518, 44.499273, 17.754672, 49.493294);
      ctx.bezierCurveTo(31.302416, 66.073273, 77.335057, 87.703669, 113.437220, 68.134557);

      tmp_cat = "3";
      tmp_color2_a = 0;
      if (cat_percent["cat" + tmp_cat + "_green"] != 0) {
        var tmp_color1_a = 0;
        var tmp_color1_b = (cat_percent["cat" + tmp_cat + "_green"] / 100) - gradient_offset;
        tmp_color2_a = tmp_color1_b + gradient_offset;
        if ( tmp_color2_a > 1) { tmp_color2_a = 1; }
        if ( tmp_color1_b > 1) { tmp_color1_b = 1; }
      }
      tmp_color3_a = tmp_color2_a;
      if (cat_percent["cat" + tmp_cat + "_yellow"] != 0) {
        var tmp_color2_b = tmp_color2_a + (cat_percent["cat" + tmp_cat + "_yellow"] / 100) - gradient_offset;
        tmp_color3_a = tmp_color2_b + gradient_offset;
        if ( tmp_color3_a > 1) { tmp_color3_a = 1; }
        if ( tmp_color2_b > 1) { tmp_color2_b = 1; }
      }
      tmp_color3_b = tmp_color3_a;
      if (cat_percent["cat" + tmp_cat + "_red"] != 0) {
        tmp_color3_b = tmp_color3_a + (cat_percent["cat" + tmp_cat + "_red"] / 100);
        if ( tmp_color3_b > 1) { tmp_color3_b = 1; }
      }

      // var gradient = ctx.createLinearGradient(glp['c' + tmp_cat][0], glp['c' + tmp_cat][1], glp['c' + tmp_cat][2], glp['c' + tmp_cat][3]);
      var gradient = ctx.createRadialGradient(
        glp['c' + tmp_cat][0], glp['c' + tmp_cat][1], glp['c' + tmp_cat][2],
        glp['c' + tmp_cat][3], glp['c' + tmp_cat][4], glp['c' + tmp_cat][5]
      );
      if (cat_percent["cat" + tmp_cat + "_green"] != 0) {
        gradient.addColorStop(tmp_color1_a, glc['c' + tmp_cat]['g'][0]);
        gradient.addColorStop(tmp_color1_b, glc['c' + tmp_cat]['g'][1]);
      }
      if (cat_percent["cat" + tmp_cat + "_yellow"] != 0) {
        gradient.addColorStop(tmp_color2_a, glc['c' + tmp_cat]['y'][0]);
        gradient.addColorStop(tmp_color2_b, glc['c' + tmp_cat]['y'][0]);
      }
      if (cat_percent["cat" + tmp_cat + "_red"] != 0) {
        gradient.addColorStop(tmp_color3_a, glc['c' + tmp_cat]['r'][0]);
        gradient.addColorStop(tmp_color3_b, glc['c' + tmp_cat]['r'][0]);
      }

      if ((cat_percent["cat" + tmp_cat + "_green"] == 0) && (cat_percent["cat" + tmp_cat + "_yellow"] == 0) && (cat_percent["cat" + tmp_cat + "_red"] == 0)) {
        ctx.fillStyle = glc['c' + tmp_cat]['w'][0];
      } else {
        ctx.fillStyle = gradient;
      }

      ctx.fill();
      ctx.stroke();

      // #!! cat2
      ctx.beginPath();
      ctx.globalAlpha = 1.0;
      ctx.strokeStyle = 'rgb(0, 0, 0)';
      ctx.lineWidth = line_thickness;
      ctx.lineJoin = 'bevel';
      ctx.moveTo(113.437220, 68.134557);
      ctx.bezierCurveTo(79.341065, 57.997938, 75.082903, 30.910466, 89.760999, 6.125422);
      ctx.bezierCurveTo(80.981510, 1.891245, 74.717365, 1.343229, 67.097720, 2.246945);
      ctx.bezierCurveTo(48.036819, 4.882886, 30.646304, 11.900736, 23.424315, 28.893592);
      ctx.bezierCurveTo(25.065808, 54.072530, 73.460801, 79.388194, 113.437220, 68.134557);

      tmp_cat = "2";
      tmp_color2_a = 0;
      if (cat_percent["cat" + tmp_cat + "_green"] != 0) {
        var tmp_color1_a = 0;
        var tmp_color1_b = (cat_percent["cat" + tmp_cat + "_green"] / 100) - gradient_offset;
        tmp_color2_a = tmp_color1_b + gradient_offset;
        if ( tmp_color2_a > 1) { tmp_color2_a = 1; }
        if ( tmp_color1_b > 1) { tmp_color1_b = 1; }
      }
      tmp_color3_a = tmp_color2_a;
      if (cat_percent["cat" + tmp_cat + "_yellow"] != 0) {
        var tmp_color2_b = tmp_color2_a + (cat_percent["cat" + tmp_cat + "_yellow"] / 100) - gradient_offset;
        tmp_color3_a = tmp_color2_b + gradient_offset;
        if ( tmp_color3_a > 1) { tmp_color3_a = 1; }
        if ( tmp_color2_b > 1) { tmp_color2_b = 1; }
      }
      tmp_color3_b = tmp_color3_a;
      if (cat_percent["cat" + tmp_cat + "_red"] != 0) {
        tmp_color3_b = tmp_color3_a + (cat_percent["cat" + tmp_cat + "_red"] / 100);
        if ( tmp_color3_b > 1) { tmp_color3_b = 1; }
      }

      // var gradient = ctx.createLinearGradient(glp['c' + tmp_cat][0], glp['c' + tmp_cat][1], glp['c' + tmp_cat][2], glp['c' + tmp_cat][3]);
      var gradient = ctx.createRadialGradient(
        glp['c' + tmp_cat][0], glp['c' + tmp_cat][1], glp['c' + tmp_cat][2],
        glp['c' + tmp_cat][3], glp['c' + tmp_cat][4], glp['c' + tmp_cat][5]
      );
      if (cat_percent["cat" + tmp_cat + "_green"] != 0) {
        gradient.addColorStop(tmp_color1_a, glc['c' + tmp_cat]['g'][0]);
        gradient.addColorStop(tmp_color1_b, glc['c' + tmp_cat]['g'][1]);
      }
      if (cat_percent["cat" + tmp_cat + "_yellow"] != 0) {
        gradient.addColorStop(tmp_color2_a, glc['c' + tmp_cat]['y'][0]);
        gradient.addColorStop(tmp_color2_b, glc['c' + tmp_cat]['y'][0]);
      }
      if (cat_percent["cat" + tmp_cat + "_red"] != 0) {
        gradient.addColorStop(tmp_color3_a, glc['c' + tmp_cat]['r'][0]);
        gradient.addColorStop(tmp_color3_b, glc['c' + tmp_cat]['r'][0]);
      }

      if ((cat_percent["cat" + tmp_cat + "_green"] == 0) && (cat_percent["cat" + tmp_cat + "_yellow"] == 0) && (cat_percent["cat" + tmp_cat + "_red"] == 0)) {
        ctx.fillStyle = glc['c' + tmp_cat]['w'][0];
      } else {
        ctx.fillStyle = gradient;
      }

      ctx.fill();
      ctx.stroke();

      // # !! cat1
      ctx.beginPath();
      ctx.globalAlpha = 1.0;
      ctx.strokeStyle = 'rgb(0, 0, 0)';
      ctx.lineWidth = line_thickness;
      ctx.lineJoin = 'bevel';
      ctx.moveTo(113.437220, 68.134557);
      ctx.bezierCurveTo(79.341065, 57.997938, 75.082903, 30.910466, 89.760999, 6.125422);
      ctx.bezierCurveTo(80.981510, 1.891245, 74.717365, 1.343229, 67.097720, 2.246945);
      ctx.bezierCurveTo(55.690836, 3.748958, 48.033210, 7.270528, 45.157946, 8.388385);
      ctx.bezierCurveTo(38.011492, 36.213155, 76.106634, 69.938788, 113.437220, 68.134557);

      tmp_cat = "1";
      tmp_color2_a = 0;
      if (cat_percent["cat" + tmp_cat + "_green"] != 0) {
        var tmp_color1_a = 0;
        var tmp_color1_b = (cat_percent["cat" + tmp_cat + "_green"] / 100) - gradient_offset;
        tmp_color2_a = tmp_color1_b + gradient_offset;
        if ( tmp_color2_a > 1) { tmp_color2_a = 1; }
        if ( tmp_color1_b > 1) { tmp_color1_b = 1; }
      }
      tmp_color3_a = tmp_color2_a;
      if (cat_percent["cat" + tmp_cat + "_yellow"] != 0) {
        var tmp_color2_b = tmp_color2_a + (cat_percent["cat" + tmp_cat + "_yellow"] / 100) - gradient_offset;
        tmp_color3_a = tmp_color2_b + gradient_offset;
        if ( tmp_color3_a > 1) { tmp_color3_a = 1; }
        if ( tmp_color2_b > 1) { tmp_color2_b = 1; }
      }
      tmp_color3_b = tmp_color3_a;
      if (cat_percent["cat" + tmp_cat + "_red"] != 0) {
        tmp_color3_b = tmp_color3_a + (cat_percent["cat" + tmp_cat + "_red"] / 100);
        if ( tmp_color3_b > 1) { tmp_color3_b = 1; }
      }
      // var gradient = ctx.createRadialGradient(33,85,30, 113,67.5,70);
      // var gradient = ctx.createLinearGradient(glp['c' + tmp_cat][0], glp['c' + tmp_cat][1], glp['c' + tmp_cat][2], glp['c' + tmp_cat][3]);
      var gradient = ctx.createRadialGradient(
        glp['c' + tmp_cat][0], glp['c' + tmp_cat][1], glp['c' + tmp_cat][2],
        glp['c' + tmp_cat][3], glp['c' + tmp_cat][4], glp['c' + tmp_cat][5]
      );
      if (cat_percent["cat" + tmp_cat + "_green"] != 0) {
        gradient.addColorStop(tmp_color1_a, glc['c' + tmp_cat]['g'][0]);
        gradient.addColorStop(tmp_color1_b, glc['c' + tmp_cat]['g'][1]);
      }
      if (cat_percent["cat" + tmp_cat + "_yellow"] != 0) {
        gradient.addColorStop(tmp_color2_a, glc['c' + tmp_cat]['y'][0]);
        gradient.addColorStop(tmp_color2_b, glc['c' + tmp_cat]['y'][0]);
      }
      if (cat_percent["cat" + tmp_cat + "_red"] != 0) {
        gradient.addColorStop(tmp_color3_a, glc['c' + tmp_cat]['r'][0]);
        gradient.addColorStop(tmp_color3_b, glc['c' + tmp_cat]['r'][0]);
      }

      if ((cat_percent["cat" + tmp_cat + "_green"] == 0) && (cat_percent["cat" + tmp_cat + "_yellow"] == 0) && (cat_percent["cat" + tmp_cat + "_red"] == 0)) {
        ctx.fillStyle = glc['c' + tmp_cat]['w'][0];
      } else {
        ctx.fillStyle = gradient;
      }

      ctx.fill();
      ctx.stroke();

      // #!! cat6 stroke outline
      ctx.beginPath();
      ctx.globalAlpha = 1.0;
      ctx.strokeStyle = 'rgb(0, 0, 0)';
      ctx.lineWidth = outline_thickness;
      ctx.lineJoin = 'bevel';
      ctx.moveTo(113.437220, 68.134557);
      ctx.bezierCurveTo(79.341065, 57.997938, 75.082903, 30.910466, 89.760999, 6.125422);
      ctx.bezierCurveTo(80.981510, 1.891245, 74.718339, 1.351481, 67.097720, 2.246945);
      ctx.bezierCurveTo(-27.682686, 13.384167, 29.206667, 162.796180, 113.437220, 68.134557);

      ctx.stroke();

      // // #rect876
      // ctx.beginPath();
      // ctx.globalAlpha = 1.0;
      // ctx.fillStyle = 'rgb(0, 0, 0)';
      // ctx.strokeStyle = 'rgb(0, 0, 0)';
      // ctx.lineWidth = rect_height;
      // ctx.lineJoin = 'bevel';
      // ctx.miterLimit = 4;
      // ctx.rect(0.742123, 8.417204, 44.121689, rect_height);
      // ctx.fill();
      // ctx.stroke();
      //
      // // #rect878
      // ctx.beginPath();
      // ctx.globalAlpha = 1.0;
      // ctx.fillStyle = 'rgb(0, 0, 0)';
      // ctx.strokeStyle = 'rgb(0, 0, 0)';
      // ctx.lineWidth = rect_height;
      // ctx.lineJoin = 'bevel';
      // ctx.miterLimit = 4;
      // ctx.rect(0.742123, 29.072857, 22.740128, rect_height);
      // ctx.fill();
      // ctx.stroke();
      //
      // // #rect880
      // ctx.beginPath();
      // ctx.globalAlpha = 1.0;
      // ctx.fillStyle = 'rgb(0, 0, 0)';
      // ctx.strokeStyle = 'rgb(0, 0, 0)';
      // ctx.lineWidth = rect_height;
      // ctx.lineJoin = 'bevel';
      // ctx.miterLimit = 4;
      // ctx.rect(0.742123, 49.775490, 17.261101, rect_height);
      // ctx.fill();
      // ctx.stroke();
      //
      // // #rect882
      // ctx.beginPath();
      // ctx.globalAlpha = 1.0;
      // ctx.fillStyle = 'rgb(0, 0, 0)';
      // ctx.strokeStyle = 'rgb(0, 0, 0)';
      // ctx.lineWidth = rect_height;
      // ctx.lineJoin = 'bevel';
      // ctx.miterLimit = 4;
      // ctx.rect(0.742123, 64.208046, 18.731085, rect_height);
      // ctx.fill();
      // ctx.stroke();
      //
      // // #rect884
      // ctx.beginPath();
      // ctx.globalAlpha = 1.0;
      // ctx.fillStyle = 'rgb(0, 0, 0)';
      // ctx.strokeStyle = 'rgb(0, 0, 0)';
      // ctx.lineWidth = rect_height;
      // ctx.lineJoin = 'bevel';
      // ctx.miterLimit = 4;
      // ctx.rect(0.742123, 77.871071, 23.809206, rect_height);
      // ctx.fill();
      // ctx.stroke();
      //
      // // #rect886
      // ctx.beginPath();
      // ctx.globalAlpha = 1.0;
      // ctx.fillStyle = 'rgb(0, 0, 0)';
      // ctx.strokeStyle = 'rgb(0, 0, 0)';
      // ctx.lineWidth = rect_height;
      // ctx.lineJoin = 'bevel';
      // ctx.miterLimit = 4;
      // ctx.rect(0.742123, 98.708598, 53.877026, rect_height);
      // ctx.fill();
      // ctx.stroke();

      // if ( document.querySelector('#alignment_lines').checked ) {
      // 	// # test to align gradient
      // 	ctx.save();
      // 	ctx.beginPath();
      // 	ctx.lineWidth = 1;
      // 	ctx.strokeStyle = 'rgba(0, 0, 255, 0.20)';
      // 	ctx.moveTo(glp['c1'][0], glp['c1'][1]);
      // 	ctx.lineTo(glp['c1'][3], glp['c1'][4]);
      // 	ctx.moveTo(glp['c2'][0], glp['c2'][1]);
      // 	ctx.lineTo(glp['c2'][3], glp['c2'][4]);
      // 	ctx.moveTo(glp['c3'][0], glp['c3'][1]);
      // 	ctx.lineTo(glp['c3'][3], glp['c3'][4]);
      // 	ctx.moveTo(glp['c4'][0], glp['c4'][1]);
      // 	ctx.lineTo(glp['c4'][3], glp['c4'][4]);
      // 	ctx.moveTo(glp['c5'][0], glp['c5'][1]);
      // 	ctx.lineTo(glp['c5'][3], glp['c5'][4]);
      // 	ctx.moveTo(glp['c6'][0], glp['c6'][1]);
      // 	ctx.lineTo(glp['c6'][3], glp['c6'][4]);

      // 	// ctx.moveTo(glp['c1'][0], glp['c1'][1]);
      // 	// ctx.lineTo(glp['c1'][2], glp['c1'][3]);
      // 	// ctx.moveTo(glp['c2'][0], glp['c2'][1]);
      // 	// ctx.lineTo(glp['c2'][2], glp['c2'][3]);
      // 	// ctx.moveTo(glp['c3'][0], glp['c3'][1]);
      // 	// ctx.lineTo(glp['c3'][2], glp['c3'][3]);
      // 	// ctx.moveTo(glp['c4'][0], glp['c4'][1]);
      // 	// ctx.lineTo(glp['c4'][2], glp['c4'][3]);
      // 	// ctx.moveTo(glp['c5'][0], glp['c5'][1]);
      // 	// ctx.lineTo(glp['c5'][2], glp['c5'][3]);
      // 	// ctx.moveTo(glp['c6'][0], glp['c6'][1]);
      // 	// ctx.lineTo(glp['c6'][2], glp['c6'][3]);
      // 	ctx.stroke();
      // 	ctx.restore();
      // }

    },
  },
};
</script>

<style lang="scss" scoped>
@media (max-width: 769px) {
  .side .spiral canvas {
    max-width: 100%;
  }
}
</style>
